import { Controller } from "@hotwired/stimulus";

// Live elapsed-time ticker for the Time Clock "clocked in" card.
// Reads the clock-in instant from startedAtValue (ISO 8601) and refreshes
// the elapsed label every 30 seconds (display granularity is minutes).
export default class extends Controller {
  static targets = ["elapsed"];
  static values = { startedAt: String };

  static REFRESH_MS = 30_000;

  connect() {
    this.render();
    this.timer = setInterval(() => this.render(), this.constructor.REFRESH_MS);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  render() {
    if (!this.hasElapsedTarget || !this.startedAtValue) return;
    const startedAt = Date.parse(this.startedAtValue);
    if (Number.isNaN(startedAt)) return;
    const totalMinutes = Math.max(0, Math.floor((Date.now() - startedAt) / 60_000));
    this.elapsedTarget.textContent = this.constructor.format(totalMinutes);
  }

  static format(totalMinutes) {
    if (totalMinutes === 0) return "0m";
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  }
}
